<div class='mao-container'>
    <h2 class="tankyou-description">We'll respond to your request shortly. In the meantime, we compare you save</h2>
    <div *ngIf="thankyouRoute === 'mao'" id="container" class="col-md-12" >
        <div id="target" (click)="thankYouTelemetryService.trackMaoInjectedOfferClick($event, currentLead)">
            <div class="loader-container">
                <span class="loader"></span>
            </div>
        </div>
    </div>
</div>
